export interface PacketCraftClassLookup {
  class: string;
  description: string;
  dayShiftRate: number | null;
  nightShiftRate: number | null;
}
